import { useEffect, useRef, useState } from 'react';

export interface UseTouchedElementProps {
  elementId: string;

  gap?: number;
  calculateOnMountDisabled?: boolean;
}

/**
 *  @description 타겟의 높이가 스크롤의 높이보다 같거나 낮아 졌을때에 대한 값을 반환합니다. isTouched
 */

export default function useTouchedElement({ elementId, gap = 1, calculateOnMountDisabled = false }: UseTouchedElementProps) {
  const [isTouched, setIsTouched] = useState<boolean>(false);
  const findStickyElementRef = useRef<HTMLElement | null>(null);

  const scrollEvent = () => {
    if (findStickyElementRef.current) {
      const elementClientRect = findStickyElementRef.current.getBoundingClientRect();
      const windowDefaultView = findStickyElementRef.current.ownerDocument.defaultView;

      const targetY = elementClientRect.top + (windowDefaultView?.pageYOffset || 0) + gap;
      const scrollY = window.scrollY ?? window.pageYOffset;

      if (scrollY >= targetY) {
        setIsTouched(true);
      } else {
        setIsTouched(false);
      }
    }
  };

  useEffect(() => {
    if (!findStickyElementRef.current) {
      const element = document.getElementById(elementId);

      findStickyElementRef.current = element || null;
    }

    if (findStickyElementRef.current) {
      const observer = new IntersectionObserver(scrollEvent);

      observer.observe(findStickyElementRef.current);

      document.addEventListener('scroll', scrollEvent);
      window.requestAnimationFrame(scrollEvent);

      scrollEvent();
    }

    return () => {
      document.removeEventListener('scroll', scrollEvent);
    };
  }, []);

  return { isTouched, calculateSticky: scrollEvent };
}
